import { render, staticRenderFns } from "./GanttView.vue?vue&type=template&id=70506ab2&scoped=true&"
import script from "./GanttView.vue?vue&type=script&lang=js&"
export * from "./GanttView.vue?vue&type=script&lang=js&"
import style0 from "./GanttView.vue?vue&type=style&index=0&id=70506ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70506ab2",
  null
  
)

export default component.exports